/**
 * QR mixin
 *
 * Добавляет логику для считывания QR кодов
 *
 */

export default {
  created() {
    this.initScanActions();
  },
  methods: {
    onScannerConnected() {
      // onConnected
    },
    onScanFinish() {
      // onScanFinish
    },
    onScanError(error) {
      console.error('barcodeService error: ', error);
      return this.showError?.();
    },
    initScanActions() {
      const robotActions = [
        this.$robot.barcodeService.onConnected(this.onScannerConnected),
        this.$robot.barcodeService.onResult(this.onScanFinish),
        this.$robot.barcodeService.onError(this.onScanError),
      ];
      this.$robot.barcodeService.getStatus();
      this.$once('hook:beforeDestroy', () => {
        robotActions.forEach((unsubscribe) => unsubscribe());
      });
    },
  },
};
